import { PureComponent } from 'react';
// import isEqual from 'lodash/isEqual';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { ChevronRight, ChevronLeft } from '@mui/icons-material';
import { LockOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Tooltip } from '@mui/material';
import { toast } from 'react-toastify';
import { fullscreenEnter, fullscreenExit } from '../../../actions/fullscreen';
import Button from '../../../components/common/Button';
import DashboardNavigationBar from './DashboardNavigationBar';
import DashboardUpdateNavigationBar from './DashboardUpdateNavigationBar';
import DashboardFilterComponent from './DashboardFilterComponent';
import { isDESMA, isDESMApremium } from '../../../utils/desma';
import { withHOCSRouter } from '../../../components/hocs';
import { canCopySharedDashboard, canEditDashboard } from '../../../utils/dashboard';
import { hasAdminEntities } from '../../../utils/jwt';
import { copyDashboard } from '../../../api/dashboard';
import { dashboardCreated } from '../../../actions/dashboard';

const CointainingDiv = styled.div`
  min-widght: 300px;
`;

const DashboardButtonsHolder = styled.nav`
  display: flex;
  align-items: center;
  user-select: none;
  @media (max-width: 900px) {
    display: none;
  }
`;

const DashboardName = styled.div`
  margin: 0 0.5rem;
  width: 200px;
  font-size: 0.8rem;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const LeftRightButton = styled.button`
  color: ${({ theme }) => theme.color};
  border-radius: 0.2rem;
  border: none;
  padding: 0.2rem;
  background: ${({ theme }) => theme.button.default.backgroundHover};
  cursor: pointer;
`;

const LeftArrow = styled(ChevronLeft)`
  display: block !important;
  font-size: 1.6rem !important;
  vertical-align: middle;
  color: ${({ theme }) => theme.secondaryDiv.color};
`;

const RightArrow = styled(ChevronRight)`
  display: block !important;
  font-size: 1.6rem !important;
  vertical-align: middle;
  color: ${({ theme }) => theme.secondaryDiv.color};
`;

const messages = defineMessages({
  START_LIVE_DATA: {
    id: 'DashboardButton.START_LIVE_DATA',
    defaultMessage: 'start live data',
  },
  STOP_LIVE_DATA: {
    id: 'DashboardButton.STOP_LIVE_DATA',
    defaultMessage: 'stop live data',
  },
  FULLSCREEN_OFF: {
    id: 'DashboardButton.FULLSCREEN_OFF',
    defaultMessage: 'Disable fullscreen',
  },
  FULLSCREEN_ON: {
    id: 'DashboardButton.FULLSCREEN_ON',
    defaultMessage: 'Enable fullscreen',
  },
  SHARING_ACTIVE: {
    id: 'DashboardButton.SHARING_ACTIVE',
    defaultMessage: 'Sharing active',
  },
  SUCCESS: {
    id: 'DashboardContainerPage.SUCCESS_DASHBOARD_COPIED',
    defaultMessage: 'Dashboard copied successfully',
  },
  ERROR: {
    id: 'DashboardContainerPage.ERROR_USER_REGISTRATION_CODE',
    defaultMessage: 'An error has occurred. Please try again',
  },
});

class DashboardButtons extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
      showMore: false,
      isFullscreen: props.isFullscreen,
    };
    this.setIsFullscreen = this.setIsFullscreen.bind(this);
  }

  setIsFullscreen() {
    const { fullscreenOn, fullscreenOff } = this.props;
    if (this.state.isFullscreen) {
      fullscreenOff();
    } else {
      fullscreenOn();
    }
    this.setState({
      isFullscreen: !this.state.isFullscreen,
    });

    this.forceUpdate();
  }

  componentDidMount() {
    this.updateWindowWidth();
    window.addEventListener('resize', this.updateWindowWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowWidth);
  }

  updateWindowWidth = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  showMoreOptions = () => {
    this.setState({ showMore: !this.state.showMore });
    this.forceUpdate();
  };

  changePage(value) {
    const { dashboard, navigate, dashboardList } = this.props;

    if (!dashboard.id) {
      return;
    }

    const dashboardKeys = Object.keys(dashboardList);
    const currentID = dashboard.id;
    const currentIndex = dashboardKeys.indexOf(currentID);
    const nextPageIndex = currentIndex + value;

    let nextPageID;
    let nextDashboard;

    if (currentIndex === 0 && value === -1) {
      nextPageID = dashboardKeys[dashboardKeys.length - 1];
      nextDashboard = dashboardList[nextPageID];
    } else if (currentIndex === dashboardKeys.length - 1 && value === 1) {
      nextPageID = dashboardKeys[0];
      nextDashboard = dashboardList[nextPageID];
    } else {
      nextPageID = dashboardKeys[nextPageIndex];
      nextDashboard = dashboardList[nextPageID];
    }

    if (nextPageID && nextDashboard) {
      // next dashboard (TODO: settings to keep query search):
      // history.push(`/dashboard/${nextPageID}/${location.search}`);
      navigate(`/dashboard/${nextPageID}/`);
    }
  }

  render() {
    const {
      location,
      navigate,
      dashboard,
      setRealtime,
      isRealtime,
      is_desma = false,
      is_desma_premium = false,
      user,
      intl: { formatMessage },
      hasAdminRights = false,
      cloneDashboard,
      is_distributor,
      editMode = false,
      setEditMode,
    } = this.props;

    const { windowWidth, showMore, isFullscreen } = this.state;

    const name = dashboard.name || null;

    let show_edit = true;
    if (is_desma && !is_desma_premium) {
      show_edit = false;
    }

    if (!name) {
      return null;
    }

    const can_edit_dashboard = canEditDashboard(dashboard, user, is_distributor);
    const can_copy_dashboard = canCopySharedDashboard(dashboard, user);

    // Auto-disable edit mode if user doesn't have permissions
    if (editMode && !can_edit_dashboard && setEditMode) {
      setEditMode(false);
    }

    const show_filter_button =
      can_edit_dashboard && dashboard.config && dashboard.config.show_filter_button;
    const show_realtime_stop_button =
      dashboard.config && dashboard.config.show_realtime_stop_button;

    return (
      <>
        <DashboardButtonsHolder>
          <LeftRightButton onClick={() => this.changePage(-1)} type="button">
            <LeftArrow />
          </LeftRightButton>
          <DashboardName className="truncate">
            <span>
              {is_distributor && dashboard.config?.restricted_access && (
                <LockOutlined style={{ marginRight: '5px' }} />
              )}
              {name}
            </span>
            {dashboard.external_user_name ? (
              <>
                <br />
                <small className="light-red">{dashboard.external_user_name}</small>
              </>
            ) : null}
            {dashboard.shared_user_name ? (
              <>
                <br />
                <Tooltip title={dashboard.shared_user_email}>
                  <small className="blue">{dashboard.shared_user_name}</small>
                </Tooltip>
              </>
            ) : null}
            {dashboard.shared_users_count ? (
              <>
                <br />
                <small className="green">
                  {formatMessage(messages.SHARING_ACTIVE) +
                    ' [' +
                    dashboard.shared_users_count +
                    ']'}
                </small>
              </>
            ) : null}
          </DashboardName>

          <LeftRightButton onClick={() => this.changePage(1)} type="button">
            <RightArrow />
          </LeftRightButton>
        </DashboardButtonsHolder>
        {editMode ? (
          <DashboardUpdateNavigationBar
            currentDashboard={dashboard}
            windowWidth={windowWidth}
            showMore={showMore}
            location={location}
            showMoreOptions={this.showMoreOptions}
            show_edit={show_edit}
            can_edit_dashboard={can_edit_dashboard}
            can_copy_dashboard={can_copy_dashboard}
            user={user}
            hasAdminRights={hasAdminRights}
            copyDashboard={cloneDashboard}
            is_distributor={is_distributor}
            setEditMode={setEditMode}
          />
        ) : (
          <CointainingDiv>
            <DashboardNavigationBar
              dashboard={dashboard}
              windowWidth={windowWidth}
              navigate={navigate}
              location={location}
              show_edit={show_edit}
              can_edit_dashboard={can_edit_dashboard}
              can_copy_dashboard={can_copy_dashboard}
              copyDashboard={cloneDashboard}
              setEditMode={setEditMode}
            />
          </CointainingDiv>
        )}
        {windowWidth >= 749 && show_realtime_stop_button && (
          <Button
            title={
              isRealtime
                ? formatMessage(messages.STOP_LIVE_DATA)
                : formatMessage(messages.START_LIVE_DATA)
            }
            icon={isRealtime ? 'fa fa-stop' : 'fa fa-play'}
            onClick={() => {
              setRealtime();
              this.forceUpdate();
            }}
            activestyle={isRealtime ? 'primary' : 'danger'}
            marginLeft
          />
        )}
        {windowWidth >= 749 && show_edit && show_filter_button && (
          <DashboardFilterComponent dashboard={dashboard} />
        )}
        {/* eslint-disable-next-line no-nested-ternary */}
        {isFullscreen && windowWidth >= 749 ? (
          <Button
            className="mr1"
            activestyle="primary"
            title={formatMessage(messages.FULLSCREEN_OFF)}
            icon="fa fa-compress-alt"
            onClick={() => {
              // fullscreenOff();
              this.setIsFullscreen();
            }}
            marginLeft
          />
        ) : windowWidth >= 749 ? (
          <Button
            className="mr1"
            activestyle="primary"
            title={formatMessage(messages.FULLSCREEN_ON)}
            icon="fa fa-expand-alt"
            onClick={() => {
              // fullscreenOn();
              this.setIsFullscreen();
            }}
            marginLeft
          />
        ) : null}
      </>
    );
  }
}

export default injectIntl(
  connect(
    (state) => ({
      dashboardList: state.dashboards,
      is_desma: isDESMA(state.config),
      is_desma_premium: isDESMApremium(state.config),
      user: state.auth.user,
      isFullscreen: state.fullscreen,
      hasAdminRights: hasAdminEntities(),
    }),
    (dispatch, { intl: { formatMessage } }) => ({
      cloneDashboard: async ({ user_id, copy_dashboard_id }) => {
        if (user_id && copy_dashboard_id) {
          try {
            const createdDashboard = await copyDashboard(copy_dashboard_id, user_id, true);
            if (createdDashboard && createdDashboard.status === 201) {
              toast.success(formatMessage(messages.SUCCESS));
              dispatch(dashboardCreated({ data: createdDashboard.body }));
            } else {
              toast.warn(formatMessage(messages.ERROR));
            }
          } catch (error) {
            toast.warn(formatMessage(messages.ERROR));
          }
        }

        return false;
      },
      fullscreenOn: () => dispatch(fullscreenEnter()),
      fullscreenOff: () => dispatch(fullscreenExit()),
    })
  )(withHOCSRouter(DashboardButtons))
);
